module.exports = __webpack_public_path__ + "img/share.36cdab22.svg";